import { gql } from '@apollo/client';

export const DELETE_WITHDRAW_REQUEST = gql`
  mutation deleteCancelRegistrationRequest(
    $input: DeleteCancelRegRequestInput!
  ) {
    deleteCancelRegistrationRequest(input: $input)
  }
`;
